import React from 'react';
import {ExpirationDatePicker} from './ExpirationDatePicker';

export const ExpirationWithInfoDatePicker = () => {
  return <ExpirationDatePicker infoText="After the chosen date the resource will no longer be available." />;
};
